import moment from "moment";
import React, { Component } from "react";
import { DateObject } from "react-multi-date-picker";
import ModalContainer from "../../../../modules/commons/ModalContainer";
import SimpleButton from "../../../../modules/commons/SimpleButton";
import SimpleModal from "../../../../modules/popup/SimpleModal";
import SimpleDataTable from "../../../../modules/SimpleDataTable";
import SimpleInput from "../../../../modules/SimpleInput";
import SimpleMonthYearPicker, {
  convertToDateObject,
} from "../../../../modules/SimpleMonthYearPicker";
import Api from "../../../../Services/Api";
import { fetchDataAsync } from "../../../../Services/Utils";
import { ACTIVITY_TYPE, HttpStatus } from "../../../common/Constants";
import { detailTableConfig } from "../config";
import service from "../service";
import "moment/locale/id";
import { defaultTableChange } from "../../../../modules/custom/customTable";

class ManagementMekanikDetail extends Component {
  constructor(props) {
    super(props);
    this.state = {
      data: {
        mechanicManagementId: null,
        mechanicManagement: moment()?.format("DD-MM-YYYY"),
        effectiveDate: null,
        dataTable: [],
      },
      errors: {},
      pagination: {
        limit: 5,
        page: 1,
      },
    };
  }

  componentDidMount() {
    if (this.props.activityType === ACTIVITY_TYPE.CREATE) {
      return this.fetchDataTable();
    }
    this.fetchDataDetail();
  }

  fetchDataTable = async () => {
    this.props.handleTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_MASTER_DATA").getAllMasterMechanic,
      menuName: "Master Mekanik",
      setError: this.props.setError,
      args: {
        kodeCabang: this.props.selectedCabang?.value,
      },
    });
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.setState((prev) => ({
        ...prev,
        data: {
          ...prev.data,
          dataTable: res.data.data?.map((item) => ({
            username: item.employee.userName,
            name: item.employee.mechanicName,
            role: item.role.value,
            unitEntryTargetQty: null || 0,
            unitServiceTargetNonKPBQty: null || 0,
            unitServiceTargetKPBQty: null || 0,
            partTargetNonOilNonSparkPlugQty: null || 0,
            oilTargetNonKPB: null || 0,
            isSaved: true,
            mechanicId: item?.mechanicId,
          })),
        },
      }));
    }
    this.props.handleTriggerLoading();
  };

  fetchDataDetail = async () => {
    this.props.handleTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").getDetailMechanicManagement,
      menuName: "Master Mekanik",
      setError: this.props.setError,
      args: {
        mechanicManagementId: this.props.selectedId,
      },
    });
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      const monthYear = moment(
        res.data.data.effectiveDate,
        "DD-MM-YYYY"
      ).format("MMMM YYYY");
      this.setState((prev) => ({
        ...prev,
        data: {
          effectiveDate: convertToDateObject(monthYear),
          mechanicManagementId: res.data.data?.mechanicManagementId,
          mechanicManagement: res.data.data?.mechanicManagement,
          dataTable: res.data.data?.detail?.map((item) => ({
            username: item?.mechanic?.employee.userName,
            name: item?.mechanic?.employee.mechanicName,
            role: item?.mechanic?.role.value,
            isSaved: true,
            unitEntryTargetQty: item.unitEntryTargetQty,
            unitServiceTargetNonKPBQty: item.unitServiceTargetNonKPBQty,
            unitServiceTargetKPBQty: item.unitServiceTargetKPBQty,
            partTargetNonOilNonSparkPlugQty:
              item.partTargetNonOilNonSparkPlugQty,
            oilTargetNonKPB: item.oilTargetNonKPB,
            mechanicId: item?.mechanicId,
            mechanicManagementDetailId: item.mechanicManagementDetailId,
            mechanicManagementId: item.mechanicManagementId,
          })),
        },
      }));
    }
    this.props.handleTriggerLoading();
  };

  handleSetValue = (name, value) => {
    this.setState((prev) => ({
      ...prev,
      data: {
        ...prev.data,
        [name]: value,
      },
    }));
  };

  handleSetTableValue = (index, name, value) => {
    this.setState((prev) => {
      const newState = [...prev.data.dataTable];

      newState[index] = {
        ...newState[index],
        [name]: value,
      };
      return {
        ...prev,
        data: {
          ...prev.data,
          dataTable: newState,
        },
      };
    });
  };

  validate = (data) => {
    const { isValid, errors } = service.validateForm(data);

    if (!isValid) {
      this.setState({ errors: errors });
      if (errors?.dataTable) {
        this.props.handleAlertInfo("Informasi", errors?.dataTable);
      }
      return;
    }
    this.setState({ errors: {} });
    return isValid;
  };

  handleSave = async () => {
    const { data } = this.state;
    if (!this.validate(data)) {
      return;
    }
    const payload = service.constructPayload(data, this.props.selectedCabang);
    this.props.handleTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").submitMechanicManagement,
      menuName: "Management Mekanik",
      setError: this.props.setError,
      args: payload,
    });
    this.props.handleTriggerLoading();
    if (res.ok && res.data.status === HttpStatus.SUCCESS) {
      this.props.onRefresh();
      this.props.onClickClose();
    }
  };

  toggleRowData = (index) => {
    this.setState((prev) => {
      const newState = [...prev.data.dataTable];

      newState[index] = {
        ...newState[index],
        isSaved: !newState[index].isSaved,
      };
      return {
        ...prev,
        data: {
          ...prev.data,
          dataTable: newState,
        },
      };
    });
  };

  getTableConfig = ({ isReadonly }) => {
    return detailTableConfig({
      onValueChange: this.handleSetTableValue,
      toggleRowData: this.toggleRowData,
      dataTable: this.state.data.dataTable || [],
      isReadonly: isReadonly,
    });
  };

  validateBulanTahun = async (data) => {
    this.props.handleTriggerLoading();
    const res = await fetchDataAsync({
      asyncFn: Api.create("NAGAMAS_TRANSACTION").checkMonthMechanicManagement,
      menuName: "Management Mekanik",
      setError: this.props.setError,
      args: {
        kodeCabang: this.props.selectedCabang?.value,
        effectiveDate: service.firstDayOfMonth(data?.format("DD-MM-YYYY")),
      },
    });
    this.props.handleTriggerLoading();
    if (res.ok) {
      if (res.data.data) {
        this.handleSetValue("effectiveDate", data);
      } else {
        this.props.handleAlertInfo(
          "Informasi",
          "Bulan Tahun Berlaku sudah digunakan. Harap pilih bulan tahun lainnya"
        );
      }
    }
  };

  handleInputBulanTahun = () => {};

  handleChangePage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page: tableState.page + 1,
      },
    }));
  };

  handleRowsPerPage = (tableState) => {
    this.setState((prevValue) => ({
      ...prevValue,
      pagination: {
        ...prevValue.pagination,
        page: 1,
        limit: tableState.rowsPerPage,
      },
    }));
  };

  render() {
    const { visible, onClickClose, activityType } = this.props;
    const { data, errors, pagination } = this.state;
    const isReadonly = activityType === ACTIVITY_TYPE.VIEW;
    return (
      <SimpleModal
        title="Detail Manajemen Mekanik"
        visible={visible}
        styles={{ width: "85%" }}
        onClickClose={() => onClickClose()}
        content={
          <ModalContainer>
            <div className="grid grid-3x grid-mobile-none gap-15px margin margin-bottom-20px">
              <SimpleInput
                label="Nomor Dokumen"
                value={data?.mechanicManagementId}
                readOnly
              />
              <SimpleInput
                label="Tanggal Dokumen"
                value={data.mechanicManagement}
                readOnly
              />
              <div className="full-month-year-picker-width">
                <SimpleMonthYearPicker
                  minDate={new DateObject().setDay(1)}
                  id="select_month_year_active"
                  name="effectiveDate"
                  label="Bulan Tahun Berlaku"
                  value={data?.effectiveDate}
                  readOnly={isReadonly}
                  errorMessage={errors?.effectiveDate}
                  mandatory
                  onChange={(value) => {
                    if (isReadonly) {
                      return;
                    }
                    this.validateBulanTahun(value);
                  }}
                />
              </div>
            </div>
            <SimpleDataTable
              key={`${data.dataTable?.length}-${pagination.page}`}
              data={data.dataTable || []}
              columns={this.getTableConfig({ isReadonly: isReadonly })}
              toCount={data.dataTable?.length}
              rowsPerPage={this.state.pagination.limit}
              page={this.state.pagination.page - 1}
              options={{...defaultTableChange(this.handleChangePage, this.handleRowsPerPage), serverSide: false}}
              footerAdditionalButtons={
                !isReadonly && (
                  <SimpleButton
                    type="button"
                    text="Simpan"
                    onClick={() => this.handleSave()}
                  />
                )
              }
            />
          </ModalContainer>
        }
      />
    );
  }
}

export default ManagementMekanikDetail;
